<template>
  <div class="main-setting-menu">
    <HeaderMenu
      :arrow="true"
      :title="$t('general.hello') + ' ' + $store.state.user.username + '!'"
    />
    <ul class="list-main-setting list-menu">
      <li class="item">
        <RowItem
          v-disable
          @click="showMyLicense"
          :title="$t('myProfile.myLicense')"
          :HasIconItem="false"
          :HasIconArrow="true"
          :HasIconDisplay="false"
          iconItem="8"
          :HasIconCheckbox="false"
          type="checkbox"
        />
        <router-view />
      </li>
      <li class="row-in-setting item" v-if="isUserIP">
        <RowItem
          v-disable
          @click="showSavePersonalData"
          :title="$t('myProfile.savingPersonalData')"
          :HasIconItem="false"
          :HasIconArrow="true"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
        />
        <router-view />
      </li>
      <li class="row-in-setting item" v-if="isUserIP">
        <RowItem
          v-disable
          @click="connectAsUser"
          :title="$t('myProfile.connectAsUser')"
          :HasIconItem="false"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
        />
        <router-view />
      </li>

      <!--  <li class="row-in-setting item">
        <RowItem
          v-disable
          @click="showHiddenList()"
          :title="$t('myProfile.personalArea')"
          :HasIconItem="false"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
        />
        <router-view />
      </li> -->

      <li class="item" v-if="!isUserIP">
        <RowItem
          v-disable
          @click="showChangePassword()"
          :title="$t('myProfile.passwordChange')"
          :HasIconItem="false"
          :HasIconArrow="true"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
        />
        <router-view />
      </li>
      <li v-if="getSubUserData.subUserId != 0" class="row-in-setting item">
        <RowItem
          v-disable
          @click="logoutSubUser"
          :title="$t('login.logoutSubUser')"
          :HasIconItem="false"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
        />
      </li>
      <!--  <li class="row-in-setting item" v-if="!isUserIP">
        <RowItem
          @click="openDisconnectSettings"
          :title="$t('myProfile.disconnectSettings')"
          :HasIconItem="false"
          :HasIconArrow="true"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
        />
        <router-view />
      </li> -->
      <li class="item">
        <RowItem
          v-disable
          @click="log_out()"
          :title="$t('myProfile.logout')"
          :HasIconItem="false"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="false"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { logoutUser, loadAllUserData } from "@/services/login";
import menuService from "@/services/menu";
import LoginMix from "@/mixing/login";
import DesktopMix from "@/mixing/mixDesktop";
export default {
  data() {
    return {
      routeBackName: "tools",
      commentsIcon: "fa fa-comment-o",
      keysIcon: "fa fa-key",
      markersIcon: "fa fa-paint-brush",
      linksIcon: "fa fa-link",
    };
  },
  mixins: [LoginMix, DesktopMix],
  computed: {
    ...mapGetters("user", ["isUserIP", "getSubUserData"]),
    hideMode() {
      const mode = this.userSettings.settings.enableHidden != "0";
      return mode;
    },
    showArrow() {
      return true;
    },
  },
  methods: {
    ...mapActions("user", ["logout", "setSubUser"]),
    ...mapActions("personalAdditionsTabs", ["clearAllPersonalAdditions"]),
    connectAsUser() {
      this.showLoginWin();
      menuService.closeMenu();
    },
    logoutSubUser() {
      this.saveCurrentDesktop(true);
      this.setSubUser({ subUserId: 0, subUserName: "" });
      this.clearAllPersonalAdditions();
      this.$store.dispatch("books/resetActiveStore");
      menuService.closeMenu();
    },
    showHiddenList() {},
    showMyLicense() {
      menuService.openMyLicense();
    },
    showChangePassword() {
      menuService.openChangePassword();
    },
    openDisconnectSettings() {
      menuService.openDisconnectSettings();
    },
    showSavePersonalData() {
      menuService.openSavePersonalData();
    },
    async resetHideBooks() {},
    log_out() {
      this.saveCurrentDesktop(true);
      this.$socket.client.emit("logout");
      logoutUser().then(async (data) => {
        this.setSubUser({ subUserId: 0, subUserName: "" });
        this.clearAllPersonalAdditions();
        this.$store.dispatch("books/resetActiveStore");
        this.logout(data);

        this.$notify({
          type: "success",
          message: this.$t("login.logoutSuccess"),
          timeout: 2000,
        });

        //load user personal data
        /*  if (globalThis.ELECTRON_ENV) globalThis.RELOAD_APP();
        else location.reload(); */
        menuService.closeMenu();
        loadAllUserData();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-setting-menu {
  width: -webkit-fill-available;
  z-index: 3;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.list-main-setting {
  display: flex;
  flex-direction: column;
  // margin: 0;
  // padding: 0;
  list-style-type: none;
}
.idle-input {
  width: 30px;
}
</style>
